module.exports = __webpack_public_path__ + "img/foto1.d50cf44e.jpg";